import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-not-found',
  templateUrl: './admin-not-found.component.html',
  styleUrls: ['./admin-not-found.component.css'],
  standalone: true
})
export class AdminNotFoundComponent {

  constructor(private r: Router) { }
 
  adminNotFoundComponent(): void {
    this.r.navigate(['adminhome']);
  }
}
